<div class="captcha-wrapper">
    <div #divRecaptcha class="captcha-container"></div>
  </div>
  